import {request} from './base'

export default {
    queryListByUserId(data) {
        return request('/userBizRecord/queryListByUserId', data, 'get')
    },
}
